<template>
  <b-row class="my-10">
    <b-col sm="4" class="pr-0">
      <label for="page-description" style="padding-top: 7px">
        <span>{{ $t("engine.managePage.pageAddEdit.seo.lblDescription", languageEngine) }}</span>
        <span class="text-hint ml-3">({{ languageUse && languageUse.toUpperCase() }})</span>
        <span class="text-hint ml-3" v-b-tooltip.hover :title="$t('engine.managePage.pageAddEdit.seo.lblDescriptionHelp', languageEngine)" >
          <i class="fas fa-question-circle"></i>
        </span>
      </label>
    </b-col>
    <b-col sm="8">
      <b-form-textarea
        rows="3"
        max-rows="8"
        id="page-description"
        :placeholder="
          desc ||
          $t(
            'engine.managePage.pageAddEdit.seo.plcDescription',
            languageEngine
          )
        "
        :value="value"
        @input="handleInput"
      ></b-form-textarea>
      <b-progress style="height: 6px; margin-top: 5px">
        <b-progress-bar
          :value="progressCal({ str: desc }).value"
          :variant="progressCal({ str: desc }).variant"
        ></b-progress-bar>
      </b-progress>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: String,
    },
    desc_default: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
    }),
    desc() {
      return this.value || this.desc_default;
    },
  },
  methods: {
    progressCal({ max_str = 150, min_str = 120, str }) {
      const percent = (str.length / max_str) * 100;
      let color = "warning";
      if (str.length > max_str) {
        color = "danger";
      } else if (str.length >= min_str) {
        color = "success";
      }
      return {
        variant: color,
        value: percent,
      };
    },
    handleInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style>
</style>